import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketsComponent } from './components/markets/markets.component';
import {MomentModule} from 'angular2-moment';
import { MarketDetailComponent } from './components/market-detail/market-detail.component';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {MyDateRangePickerModule} from 'mydaterangepicker';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {AngularOpenlayersModule} from 'ngx-openlayers';
import { AssortmentService } from '../shared/services/assortment.service';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  imports: [
    CommonModule,
    MomentModule,
    RouterModule,
    SharedModule,
    MyDateRangePickerModule,
    NgxDatatableModule,
    AngularOpenlayersModule,
    AgmCoreModule
  ],
  declarations: [MarketsComponent, MarketDetailComponent],
  providers: [AssortmentService]
})
export class MarketsModule { }



// WEBPACK FOOTER //
// ./src/app/markets/markets.module.ts